import React from 'react';
import { useMandatoryRating } from '@/hooks/useMandatoryRating';
import { RatingModal } from './RatingModal';

export function RatingInterceptor() {
  const { pendingRating, refresh } = useMandatoryRating();

  return (
    <RatingModal
      isOpen={!!pendingRating}
      appointment={pendingRating}
      onSuccess={refresh}
    />
  );
}
